import { ChartLegend } from '../../../core/components/legend/categorical/ChartLegend.js';
import type { LegendItem } from '../../../core/components/legend/categorical/types/legend.js';
import { LegendSizeContext } from '../../../core/components/legend/shared/context/LegendSizeContext.js';
import { useTooltipReducer } from '../../../core/components/overlay-tooltip/useTooltipReducer.js';
import { useMeterBarChartLoading } from '../../shared/context/MeterBarChartLoadingContext.js';
import { useMeterBarLayoutSize } from '../../shared/context/MeterBarLayoutSizeContext.js';
import { useMultiMeterBarSegmentsState } from '../hooks/store/selectors.js';
import { useMultiMeterBarStore } from '../hooks/useMultiMeterBarStore.js';

export const MultiMeterBarChartLegend = () => {
  const { segmentWidth: width } = useMeterBarLayoutSize();
  const { setVisibleSegments, setHighlightedSegment } = useMultiMeterBarStore();
  const loading = useMeterBarChartLoading();

  const dispatch = useTooltipReducer();

  const segments = useMultiMeterBarSegmentsState();

  const legendItems = segments.map((segment) => ({
    id: segment.id,
    color: {
      Default: segment.color,
    },
    name: segment.name,
  }));

  const onClickHandler = (visibleSegments: LegendItem[]) => {
    setVisibleSegments(visibleSegments);
    dispatch({ type: 'RESET_TOOLTIP' })();
  };

  const onHoverHandler = (highlightedSegment?: LegendItem) => {
    if (loading) {
      return;
    }
    setHighlightedSegment(highlightedSegment);
  };

  return (
    // the height value is set through the CSS style
    <LegendSizeContext.Provider value={{ width, height: 0 }}>
      <ChartLegend
        items={legendItems}
        onClick={onClickHandler}
        onHover={onHoverHandler}
        interactionsDisabled={loading}
        style={{ height: '100% ' }}
      />
    </LegendSizeContext.Provider>
  );
};

MultiMeterBarChartLegend['displayName'] = 'MultiMeterBarChartLegend';
